export const UNLINK_STUDENT_MODAL_OPEN = 'UNLINK_STUDENT_MODAL_OPEN';
